(function ($) {
  'use strict';

  $.extend(true, $.trumbowyg, {
    langs: {
      en: {
        insertPlaceholder: 'Insert placeholder'
      }
    },
    plugins: {
      insertPlaceholder: {
        init: function (trumbowyg) {
          var btnDef = {
            fn: function () {
              var title_html = '<div class="trumbowyg-modal-title">Insert Placeholder</div>';
              var controls_html =
                '<form action>' +
                  '<div class="form-group">' +
                    '<label style="height: auto; overflow: visible;" id="placeholder-multiselect-container">' +
                      '<select id="insert-placeholder-box" name="placeholder"><option value="">Select a placeholder</option></select>' +
                    '</label>' +
                    '<div class="submit-button-container flex-row-reverse">' +
                      '<button class="button trumbowyg-modal-submit" type="submit">Confirm</button>' +
                      '<button class="button secondary trumbowyg-modal-reset" type="reset">Cancel</button>' +
                    '</div>' +
                  '</div>' +
                '</form>';

              trumbowyg.openModal(null, title_html + controls_html, false);

              $.ajax({
                type: 'GET',
                url: '/admin/utilities/placeholders',
                dataType: 'json',
                data: trumbowyg.o.extra,
                success: function(data) {
                  console.log('placeholders fetched')
                  const transformedOptions = data.map(function(item) {
                    return {
                      text: item.name_and_title || item.name || item.title,
                      value: item.name,
                      description: item.description
                    };
                  });

                  const strOptions = JSON.stringify(transformedOptions).replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');

                  // Create the multiselect element
                  var multiselectHtml =
                    '<div data-controller="extended-form-controls"> ' +
                      '<Multiselect ' +
                        'name="placeholder" ' +
                        'id="insert-placeholder-box" ' +
                        ':initial-selected-values="[]" ' +
                        ':options="' + strOptions + '" ' +
                        ':max-items="1" ' +
                      '></Multiselect>' +
                    '</div>';

                  const container = document.getElementById('placeholder-multiselect-container');
                  container.innerHTML = multiselectHtml;
                }
              })

              $('.trumbowyg-modal-submit').on('click', function(e) {
                e.preventDefault();

                let html;

                const hiddenSelect = $('#insert-placeholder-box select[name="placeholder"]');
                const placeholder = hiddenSelect.val() ? hiddenSelect.val()[0] : null;

                if (!placeholder) {
                  trumbowyg.closeModal();
                  return;
                }

                  var selectedText = hiddenSelect.find('option:selected').text() || '';

                if (placeholder.includes("_URL") || placeholder.includes("_LINK") || selectedText.includes("URL")) {
                  html = `<a href="{${placeholder}}">Click here</a>`;
                } else {
                  html = `<a href="#" class="placeholder-token">${placeholder}&nbsp;</a>`;
                }

                trumbowyg.restoreRange();
                trumbowyg.execCmd('insertHTML', html, false, true);
                $(this).off();
                trumbowyg.closeModal();
              });

              $('.trumbowyg-modal-reset').on('click', function() {
                trumbowyg.closeModal();
              });
            }
          };

          trumbowyg.addBtnDef('insertPlaceholder', btnDef);
        }
      }
    }
  });
})(jQuery);
